import { render, staticRenderFns } from "./templateScenarios.vue?vue&type=template&id=9804683c&scoped=true&"
import script from "./templateScenarios.vue?vue&type=script&lang=js&"
export * from "./templateScenarios.vue?vue&type=script&lang=js&"
import style0 from "./templateScenarios.vue?vue&type=style&index=0&id=9804683c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9804683c",
  null
  
)

export default component.exports